import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { workOrderAssignmentRecordQuery } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrderAssignmentQuery";

export function useWorkOrderAssignment(assignmentId: string) {
  const { data } = useSuspenseGqlQuery(workOrderAssignmentRecordQuery, {
    id: assignmentId,
  });

  if (!data.workOrderAssignment) {
    throw new Error("Assignment not found");
  }

  return data.workOrderAssignment;
}
